import {
  IconBell,
  IconBooks,
  IconBuildingFactory2,
  IconChecklist,
  IconDatabase,
  IconFileDescription,
  IconFlask,
  IconHistory,
  IconLayoutDashboard,
  IconShieldLock,
  IconUsers,
  type Icon,
} from '@tabler/icons-react';
import type { AppModule, PermissionAction, Role } from '@mexp/shared';

export interface NavItem {
  label: string;
  to: string;
  icon: Icon;
  module?: AppModule;
  action?: PermissionAction;
  roles?: Role[];
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    label: 'Overview',
    items: [
      { label: 'Dashboard', to: '/internal', icon: IconLayoutDashboard, module: 'Dashboard' },
      { label: 'Notifications', to: '/internal/notifications', icon: IconBell },
    ],
  },
  {
    label: 'Document requests',
    items: [
      { label: 'Requests', to: '/internal/requests', icon: IconFileDescription, module: 'DossierRequests' },
      { label: 'My tasks', to: '/internal/my-tasks', icon: IconChecklist, module: 'MyTasks' },
    ],
  },
  {
    label: 'Library',
    items: [
      { label: 'Data Bank', to: '/internal/data-bank', icon: IconDatabase, module: 'DataBank' },
      { label: 'Technical documents', to: '/internal/technical-documents', icon: IconFlask, module: 'TechnicalDocuments' },
      { label: 'Pharmacopoeia', to: '/internal/pharmacopoeia', icon: IconBooks, module: 'Pharmacopoeia' },
    ],
  },
  {
    label: 'Administration',
    items: [
      { label: 'Exporters', to: '/internal/exporters', icon: IconBuildingFactory2, module: 'Exporters' },
      { label: 'Users', to: '/internal/users', icon: IconUsers, module: 'Users' },
      { label: 'Access control', to: '/internal/access-control', icon: IconShieldLock, module: 'AccessControl' },
      { label: 'Activity log', to: '/internal/activity', icon: IconHistory, module: 'ActivityLog' },
    ],
  },
];

/** Routes that exist in this build; nav items for later phases stay hidden until they land. */
export const AVAILABLE_ROUTES = new Set<string>([
  '/internal',
  '/internal/notifications',
  '/internal/requests',
  '/internal/my-tasks',
  '/internal/data-bank',
  '/internal/technical-documents',
  '/internal/pharmacopoeia',
  '/internal/exporters',
  '/internal/users',
  '/internal/access-control',
  '/internal/activity',
]);
